import { render, staticRenderFns } from "./policy_accept.vue?vue&type=template&id=22fb6447&lang=pug&"
import script from "./policy_accept.vue?vue&type=script&lang=js&"
export * from "./policy_accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports